import { Select } from 'antd';
import React from 'react';
import filterSVG from '../../../assets/icons/filter.svg';
import filterActiveSVG from '../../../assets/icons/filter-active.svg';
import { IFormFields } from '../field-edit-form/field-edit-form';
import './filter-select.less';

interface ISelect {
  currentFilter: string;
  onChange: (value: string) => void;
  data: Array<IFormFields> ;
  disabled?: boolean;
  defaultValue?: string;
  value?: string;
}

const FilterSelect: React.FC<ISelect> = ({
  currentFilter, defaultValue = '', onChange, data, disabled = false, value,
}: ISelect): JSX.Element => {
  const { Option } = Select;
  const isControlled = typeof value !== 'undefined';

  return (
    <Select
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(isControlled
        ? { value }
        : { defaultValue })}
      className={currentFilter ? 'filter active' : 'filter'}
      onChange={onChange}
      optionLabelProp="label"
      placeholder={(
        <>
          <img src={filterSVG} alt={filterSVG} />
          &nbsp; Filter
        </>
      )}
      disabled={disabled}
    >
      <Option
        value=""
        label={(
          <>
            <img src={filterSVG} alt={filterSVG} />
            &nbsp; Filter
          </>
        )}
      >
        Filter
      </Option>
      {data.map((el, index) => (
        <Select.Option
          key={`${el.name}-${index}`}
          value={el.value}
          label={(
            <>
              <img src={filterActiveSVG} alt={filterActiveSVG} />
              &nbsp;
              {el.name}
            </>
          )}
        >
          {el.name}
        </Select.Option>
      ))}
    </Select>
  );
};

FilterSelect.displayName = 'FilterSelect';
export default FilterSelect;
